import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import { getValueFromResource, setItemStatus } from '../../../common/timeLiveFunction';
import ZoneTypeForm from './ZoneTypeForm';
import { DeleteAccountGeoFenceZoneType, getAccountGeoFenceZoneType } from './GeofencingSlice';
import clsx from 'clsx';
import { Dropdown } from 'react-bootstrap';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { ShowToast } from '../../../common/Toastr';
import Loader from '../../../common/Loader';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { getPagePermissions } from '../../dashboard/dashboardSlice';
import { useNavigate } from 'react-router-dom';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";

const ZoneType = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isLoading, zoneTypeList } = useAppSelector((state) => state.geofencing);
    const [isShow, setIsShow] = useState(false);
    const [zoneTypeId, setZoneTYpeId] = useState(null);
    const [permissions, setPermissions] = useState({
            IsList: false,
            IsAdd: false,
            IsEdit: false,
            IsDelete: false,
        });
    
        const getPermission = async () => {
            try {
                const res = await dispatch(getPagePermissions(512));
                if (res.meta?.requestStatus === 'fulfilled') {
                    if (!res?.payload?.IsList) {
                        navigate('../error/403');
                        return;
                    }
                    setPermissions({
                        IsList: res?.payload?.IsList ?? false,
                        IsAdd: res?.payload?.IsAdd ?? false,
                        IsEdit: res?.payload?.IsEdit ?? false,
                        IsDelete: res?.payload?.IsDelete ?? false,
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };

    useEffect(() => {
        getPermission();
        dispatch(getAccountGeoFenceZoneType());
    }, [])

    const handleEditZoneType = async (id: any) => {
        setZoneTYpeId(id);
        setIsShow(true);
    }

    const handleDeleteZoneType = async (id: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then(async (result) => {
                if (result) {
                    try {
                        const response = await fetchTimeliveAPI(`api/GeoFenceZoneType/DeleteAccountGeoFenceZoneType/${id}`, `DELETE`, '', true);
                        const json = await response.json();
                        if (json?.StatusCode === '200') {
                            ShowToast('Success', json.ResponseMessage, 'success', "toast-top-right");
                            dispatch(getAccountGeoFenceZoneType())
                        } else {
                            ShowToast('error', json.ResponseMessage, "error", "toast-top-right")
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            })
            .catch((error) => {
            });
    }

    const closeModal = () => {
        setIsShow(false);
        setZoneTYpeId(null)
    };

    return (
        <div>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading d-flex align-items-center gap-1">
                        {getValueFromResource('Zone Type', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-description"
                            data-tooltip-content={getValueFromResource('Create and manage geofence zones by selecting a location on the map, defining a radius, and saving the corresponding address. These zones are later used for validating employee location during attendance actions.', dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    {permissions?.IsAdd && <div className="card-toolbar align-items-center">
                        <button type="button"
                            className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                            style={{ marginRight: '2px', display: 'block' }}
                            onClick={() => setIsShow(!isShow)}
                        >
                            {getValueFromResource('Add Zone Type', dispatch, t)}

                        </button>
                    </div>}
                </div>
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                            <thead>
                                <tr className="thHeading align-middle">
                                    <th style={{ width: '15%' }}> {getValueFromResource('Active / Inactive', dispatch, t)}</th>
                                    <th style={{ width: '70%' }}>{getValueFromResource('Zone Type', dispatch, t)}</th>
                                    <th className='w-10 text-center'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {zoneTypeList?.length > 0 && zoneTypeList?.map((item: any) => {
                                    return (
                                        <tr>
                                            <td>
                                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled ? "InActive" : "Active"))}>
                                                    {item.IsDisabled ? "InActive" : "Active"}
                                                </span>
                                            </td>
                                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '>
                                                <span className="d-block " onClick={() => { if(permissions?.IsEdit)handleEditZoneType(item?.AccountGeoFenceZoneTypeId) }}>{item?.ZoneTypeName}</span>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content={getValueFromResource('More', dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-three-dots fs-7"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                        {permissions?.IsEdit && <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => handleEditZoneType(item?.AccountGeoFenceZoneTypeId)}
                                                            >
                                                                <span className="menu-icon custom-menu">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('Edit', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>}
                                                        {/* <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                        <div className='menu-hover-bg-danger'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => handleDeleteZoneType(item?.AccountGeoFenceZoneTypeId)}
                                                            >
                                                                <span className="menu-icon  custom-menu">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color " >
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                    {getValueFromResource('Delete', dispatch, t)}

                                                                </span>
                                                            </Dropdown.Item>
                                                        </div> */}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isShow && <ZoneTypeForm oncloseModal={closeModal} id={zoneTypeId} />}
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="bottom"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </div>
    )
}

export default ZoneType